import React, { FC, HTMLAttributes } from 'react';
import './loader.scss';
import Spinner from '../spinner/Spinner';
import { LoaderSvg, LoaderSvgBitiba } from '@zooplus/ui-components';
import classNames from 'classnames';

export interface LoaderProps extends HTMLAttributes<HTMLDivElement> {
  isLoading: boolean;
  variant?: 'default' | 'zooplus' | 'bitiba';
  isSimple?: boolean;
  size?: number;
}

const Loader: FC<LoaderProps> = ({
  isLoading,
  variant = 'default',
  isSimple = false,
  children,
  size = undefined,
}) => {
  const LoaderComponent = () => {
    switch (variant) {
      case 'zooplus':
        return <LoaderSvg />;
      case 'bitiba':
        return <LoaderSvgBitiba />;
      default:
        return <Spinner size={size} />;
    }
  };
  return (
    <>
      {isLoading && (
        <div
          className={classNames(`loader loader--${variant}`, { 'loader--simple': isSimple })}
          data-test="loader">
          <div className="loader__wrapper">
            <LoaderComponent />
          </div>
        </div>
      )}
      {!isLoading && children}
    </>
  );
};

export default Loader;
